import React from "react";
import { cn } from "@/utils";

export type ButtonSize = "md" | "lg";
export type ButtonVariant =
  | "primary"
  | "light"
  | "dark"
  | "outline"
  | "outline-dark"
  | "text"
  | "text-dark";

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  size?: ButtonSize;
  variant?: ButtonVariant;
}

const Button: React.FC<ButtonProps> = ({
  className,
  size = "md",
  disabled = false,
  variant = "primary",
  children,
  ...props
}) => {
  return (
    <button
      className={cn(
        size === "md" && "py-4 md:px-6 px-3",
        size === "lg" && "py-5 md:px-6 px-3",
        disabled ? "cursor-not-allowed" : "cursor-pointer",
        disabled && "opacity-50",
        !disabled &&
          `${variant === "primary" && "hover:bg-primary-hover hover:border-y-dark"} ${
            variant === "light" && "hover:bg-dark-hover"
          } ${variant === "dark" && "hover:bg-dark-hover"} ${
            variant === "outline" && "hover:bg-dark-hover hover:text-emerald-50"
          } ${variant === "outline-dark" && "hover:bg-gray-50 hover:text-dark"} ${
            variant === "text" && "hover:border-y-primary-hover"
          }`,
        variant === "primary" && "bg-primary border-primary",
        variant === "light" && "bg-emerald-50 border-primary",
        variant === "dark" && "bg-dark border-dark",
        variant === "outline" && "bg-transparent border-dark",
        variant === "outline-dark" && "bg-transparent border-emerald-50",
        variant === "text" && "bg-transparent border-transparent",
        variant === "light" && "text-dark border-y border-emerald-50 hover:text-emerald-50",
        (variant === "outline" || variant === "text") && "text-dark border",
        variant === "outline-dark" && "text-gray-50 border",
        (variant == "primary" || variant == "dark") && "text-emerald-50 border-y",
        "md:text-base text-sm",
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
